<div class="back_col page-wrapper">
<header>
  <nav class="navbar navbar-expand-lg navbar-light Header">
    <h5 class="my-0 resp-mar font-weight-normal">
      <i class="fa fa-long-arrow-left cursor-point"
         data-toggle="tooltip" title="Acceuil"
         (click)="onRedirectHome()"></i></h5>
    <div>
      <img class="ekaidi_img" src="assets/images/ekaidi_max.png">
    </div>
    <button class="navbar-toggler" type="button" (click)="show=!show">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse text-center" [ngClass]="{'show' : show}">
      <ul class="nav navbar-nav ml-auto">
        <div class="nav-link my-2 my-md-0 mr-md-3">
          <button class="btn btn-primary mb-1 respon" (click)="onRedirectlogin()">
            <i class="fa fa-lock mr-2" aria-hidden="true"></i>
            <span class="button-font" translate>haveacc</span>
          </button>
        </div>
      </ul>
    </div>
  </nav>
</header>
<div class="marg container back_col content">
<p>
  <span class="font-col" (click)="onRedirectHome()" translate>bred_appointment</span>
  <span class="_font-col text-muted" translate>passtrackbred</span>
</p>
<div>
  <div class="card shadow-sm p-4">

    <h4 class="mb-3">
      <i class="bi bi-file-earmark-text me-2"></i>
      <span translate>track_title</span>
    </h4>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <div class="row g-3">
        <!-- Nom -->
        <div class="col-md-3">
          <label for="nom" class="form-label" translate>
            nom_nec <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="nom"
            class="form-control"
            [placeholder]="'nom_nec' | translate"
            formControlName="nom">
          <small class="text-danger" *ngIf="form.get('nom')?.invalid && form.get('nom')?.touched" translate>
            ln_req
          </small>
        </div>

        <!-- Date de naissance -->
        <div class="col-md-3">
          <label for="dateNaissance" class="form-label" translate>
            naiss <span class="text-danger">*</span>
          </label>
          <input
            type="date"
            id="dateNaissance"
            class="form-control"
            formControlName="dateNaissance">

          <small class="text-danger" *ngIf="form.get('dateNaissance')?.invalid && form.get('dateNaissance')?.touched"
                 translate>
            datebirth_req
          </small>
        </div>

        <!-- Carte consulaire -->
        <div class="col-md-3">
          <label for="numCarteConsulaire" class="form-label" translate>
            cid <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="numCarteConsulaire"
            class="form-control"
            formControlName="numCarteConsulaire"
            placeholder="N° CID">

          <small class="text-danger"
                 *ngIf="form.get('numCarteConsulaire')?.invalid && form.get('numCarteConsulaire')?.touched" translate>
            cid_req
          </small>
        </div>

        <!-- Num personnel -->
        <div class="col-md-3">
          <label for="numPersonnel" class="form-label" translate>
            num_pers<span class="text-danger"> *</span>
          </label>
          <input
            type="text"
            id="numPersonnel"
            class="form-control"
            formControlName="numPersonnel"
            placeholder="1X7908RG0995678">

          <small class="text-danger"
                 *ngIf="form.get('numPersonnel')?.invalid && form.get('numPersonnel')?.touched" translate>

  <span *ngIf="form.get('numPersonnel')?.hasError('required')" translate>
   num_pers_req
  </span>
            <span *ngIf="form.get('numPersonnel')?.hasError('pattern')" translate>
    numb_req
  </span>
          </small>
        </div>
      </div>
      <!-- Bouton -->
      <button
        type="submit"
        class="btn btn-primary mt-4"
        [disabled]="form.invalid || spinner" translate>
        recherche
        <span
          *ngIf="spinner"
          class="spinner-border spinner-border-sm ms-2"
          role="status">
      </span>
      </button>

    </form>

  </div>
</div>
<div *ngIf="trackResp?.data != null" #resultSection class="container my-4 mt-5">
  <div class="p-4">
    <h4 *ngIf="trackResp.data.withdrawn" class="text-center text-primary mb-4" translate>
      pass_d
    </h4>

    <h4 *ngIf="!trackResp.data.available" class="text-center text-primary mb-4" translate>
      pass_notif
    </h4>

    <h4 *ngIf="trackResp.data.available && !trackResp.data.withdrawn" class="text-center text-primary mb-4" translate>
      pass_dispo
    </h4>

    <div class="stepper d-flex flex-column flex-md-row align-items-center justify-content-center">

      <!-- STEP 1 -->
      <div class="step-item animated-item">
        <div class="step-circle bg-success"></div>
        <span class="step-label" translate>enroll</span>
      </div>

      <div class="arrow animated-item"></div>

      <!-- STEP 2 -->
      <div class="step-item animated-item">
        <div class="step-circle bg-success"></div>
        <span class="step-label" translate>reqsent</span>
      </div>

      <div class="arrow animated-item"></div>

      <!-- STEP 3 -->
      <div class="step-item animated-item">
        <div
          class="step-circle"
          [ngClass]="{
      'bg-danger': !trackResp.data.available,
      'bg-success': trackResp.data.available
    }">
        </div>
        <span class="step-label" translate>processing</span>
      </div>
      <div class="arrow animated-item"></div>
      <!-- STEP 4 -->
      <div class="step-item animated-item">
        <div
          class="step-circle"
          [ngClass]="{
      'bg-secondary': !trackResp.data.available && !trackResp.data.withdrawn,
      'bg-danger': trackResp.data.available && !trackResp.data.withdrawn,
      'bg-success': trackResp.data.withdrawn
    }">
        </div>
        <span class="step-label">
  {{ (trackResp.data.withdrawn ? 'passdeliv' : 'passdispo') | translate }}
</span>
      </div>
    </div>
  </div>
</div>
</div>
<footer class="_footer">
  <div class="container">
    <div class="row justify-content-center custom-foo">
      <div class="col-md-4 text-white text-center">
        <div class="mt-4">
          <p class="text-light">
            <img src="assets/images/logo.png"
                 class="mr-1 mb-1"
                 style="width: 43px; height: 23px"/><span class="button-font">&copy;2020 A2A Expertise</span>
          </p>
        </div>
      </div>

      <div class="col-md-4 text-white text-center">
        <div class="mt-4">
          <div>
            <p><i class="fa fa-envelope mt-1 mr-2"></i><a
              href="mailto:consulats@ambaguinee.org" style="color: #1587bd">consulats@ambaguinee.org</a></p>
          </div>
        </div>
      </div>

      <div class="col-md-4 text-white text-center">
        <div class="mt-3 pt-1">
          <a href="https://www.facebook.com/A2A-Expertise-2065223603792416/"><i
            class="fa fa-facebook fa-2x text-primary mx-3"></i></a>
          <a href="https://www.linkedin.com/company/a2a-expertise"><i class="fa fa-linkedin fa-2x text-danger mx-3"></i></a>
          <a href="https://twitter.com/"><i class="fa fa-twitter fa-2x text-info mx-3"></i></a>
          <a href="https://www.youtube.com/watch?v=l21QDxgQjSc"><i class="fa fa-youtube fa-2x text-danger mx-3"></i></a>
        </div>
      </div>
    </div>
  </div>
</footer>
</div>
<div
  bsModal
  #errorModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-error"
  aria-hidden="true">

  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="dialog-error">Erreur</h5>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <p translate>{{ error }}</p>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="errorModal.hide()" translate>close</button>
      </div>

    </div>
  </div>
</div>
